/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef, useState } from 'react';
import { DialogActions, List, CircularProgress, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ListItemFolder from './ListItemFolder';
import { CreateChatCategory } from './CreateChatCategory';
import styles from './ChatCategories.module.scss';
import { getChats } from '../../../api/chat/endpoints/chat';
import { Button, Modal } from 'tt-ui-lib/core';
import { useSelectedContext } from 'context/contextSelector';

export const ChatCategoriesModal = ({
  getAllChats,
  activeFolderId,
  userId,
  open = false,
  handleClose,
  chats = [],
}) => {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isFetchingChats, setIsFetchingChats] = useState(false);
  const [isCreatingFolder, setIsCreatingFolder] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [allChats, setAllChats] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [getMore, setGetMore] = useState(false);
  const [lastList, setLastList] = useState(false);
  const [chatCategoryFormData, setChatCategoryFormData] = useState({
    name: '',
    color: '',
    chats: [],
  });

  const openRequestedRef = useRef(false);
  const modalStillOpenRef = useRef(false);

  const { handleCreateFolder, chatFolders, handleDeleteFolder } = useSelectedContext(
    (ctx) => ctx.messenger
  );

  useEffect(() => {
    modalStillOpenRef.current = open;
    if (!open) {
      openRequestedRef.current = false;
      setIsFetchingChats(false);
      setIsCreatingFolder(false);
    }
  }, [open]);

  const createChatFolder = async () => {
    if (isCreatingFolder) return;
    setIsCreatingFolder(true);

    try {
      await handleCreateFolder(chatCategoryFormData);
      setOpenCreateModal(false);
    } finally {
      setIsCreatingFolder(false);
    }
  };

  const getChatsList = () => {
    if (isFetchingChats || !modalStillOpenRef.current) return;

    setIsFetchingChats(true);
    openRequestedRef.current = true;

    getChats({ first: 10, page })
      .then((res) => {
        if (!modalStillOpenRef.current) {
          setIsFetchingChats(false);
          return;
        }

        if (res.data.chats.length === 0) {
          setLastList(true);
          setGetMore(false);
        } else if (getMore) {
          setAllChats((cur) => [...cur, ...res.data.chats]);
          setGetMore(false);
        } else {
          setAllChats(res.data.chats);
        }

        if (openRequestedRef.current) setOpenCreateModal(true);

        setPageCount(Math.ceil(res.data.count_pages / 10));
        setIsFetchingChats(false);
      })
      .catch(() => setIsFetchingChats(false));
  };

  useEffect(() => {
    if (getMore && !isFetchingChats) getChatsList();
  }, [getMore, isFetchingChats]);

  const fetchMoreUsers = () => {
    if (page < pageCount && !getMore) {
      setPage((prev) => prev + 1);
      setGetMore(true);
    }
  };

  const onScrollUsers = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    if (scrollHeight - scrollTop - 1 <= clientHeight && !lastList) fetchMoreUsers();
  };

  return (
    <div>
      <Modal open={open} onClose={handleClose} title="Folders" onClick={(e) => e.stopPropagation()}>
        <>
          <div className={styles.foldersList} style={{ position: 'relative' }}>
            <List sx={{ width: '100%', opacity: isFetchingChats || isCreatingFolder ? 0.5 : 1 }}>
              {chatFolders.map((folder) => (
                <ListItemFolder
                  key={folder.id}
                  folder={folder}
                  handleDelete={() => {
                    handleDeleteFolder(folder.id);
                    getAllChats();
                  }}
                />
              ))}
            </List>

            {(isFetchingChats || isCreatingFolder) && (
              <Box
                position="absolute"
                top={0}
                left={0}
                width="100%"
                height="100%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                bgcolor="rgba(255,255,255,0.6)"
              >
                <CircularProgress size={32} />
              </Box>
            )}
          </div>
          <DialogActions className={styles.dialogActions}>
            <Button
              type="default"
              disabled={chatFolders.length > 9 || isFetchingChats || isCreatingFolder}
              className={styles.dialogActionButton}
              onClick={getChatsList}
            >
              <AddIcon className={styles.dialogActionButtonIcon} /> New folder
            </Button>
          </DialogActions>
        </>
      </Modal>

      <CreateChatCategory
        open={openCreateModal}
        onClose={() => {
          setOpenCreateModal(false);
          openRequestedRef.current = false;
        }}
        searchValue={searchValue}
        changeSearchValue={setSearchValue}
        chats={allChats}
        create={createChatFolder}
        creating={isCreatingFolder}
        formData={chatCategoryFormData}
        changeFormData={(name, value) =>
          setChatCategoryFormData((cur) => ({ ...cur, [name]: value }))
        }
        onScrollUsers={onScrollUsers}
        getMore={getMore}
        userId={userId}
        activeFolderId={activeFolderId}
      />
    </div>
  );
};
